import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isNil } from 'lodash-es';

export enum MessageDialogComponentButtons {
  OK = 0,
  OkCancel = 1,
  YesNo = 2
}
export interface IMessageDialogComponentInParams {
  title: string;
  message?: string;
  warning?: string;
  buttons?: MessageDialogComponentButtons;
}
@Component({
  selector: 'datex-common-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  standalone: false
})
export class MessageDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IMessageDialogComponentInParams) {
    if (isNil(data.buttons)) {
      data.buttons = MessageDialogComponentButtons.OkCancel;
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  get isOkOnlyButton() {
    return this.data.buttons === MessageDialogComponentButtons.OK;
  }
  get isOkCancelButton() {
    return this.data.buttons === MessageDialogComponentButtons.OkCancel;
  }
  get isYesNoButton() {
    return this.data.buttons === MessageDialogComponentButtons.YesNo;
  }
}
